// extracted by mini-css-extract-plugin
module.exports = {"Saved":"StorageIcon_Saved__Topjh","Unsaved":"StorageIcon_Unsaved__1vRdq","rotate":"StorageIcon_rotate__3i0AV","NoUser":"StorageIcon_NoUser__2evm4"};